import React from "react"
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6"

export interface CheckboxOption {
  value: string
  label?: string
}

export interface CheckboxGroupProps {
  options: CheckboxOption[]
  selectedValues: string[] // Array of selected values
  onChange: (values: string[]) => void // Callback when the selected values change
  className?: string // Optional custom class for the container
  buttonClassName?: string // Optional custom class for each button
  checkboxIconClassName?: string // Optional custom class for the checkbox icons
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange,
  className = "",
}) => {
  const isSelected = (value: string) => selectedValues.includes(value)

  const handleCheckboxClick = (value: string) => {
    if (isSelected(value)) {
      onChange(selectedValues.filter((v) => v !== value))
    } else {
      onChange([...selectedValues, value])
    }
  }

  return (
    <div className={`grid grid-cols-1 gap-4 ${className}`}>
      {options.map((item, index) => (
        <div
          key={index}
          className={`flex items-center space-x-2 cursor-pointer  `}
          onClick={() => handleCheckboxClick(item.value)}
        >
          {isSelected(item.value) ? (
            <FaSquareCheck color="white" />
          ) : (
            <FaRegSquare color="#C2C2C2AA" />
          )}
          <span className="text-md text-white font-regular">{item.value}</span>
        </div>
      ))}
    </div>
  )
}

export default CheckboxGroup
